import { useEffect } from "react";
import { getCandidate } from "../admin/hooks/useProfile";
import { useUserProfileStore } from "./useUserProfileStore";

export function useSyncUserProfile(isLoggedIn: boolean) {
  const setProfile = useUserProfileStore((s) => s.setProfile);
  const clearProfile = useUserProfileStore((s) => s.clearProfile);

  useEffect(() => {
    if (!isLoggedIn) {
      clearProfile();
      return;
    }
    getCandidate()
      .then((data) => {
        if (data && typeof data === "object") {
          const nome = data.pessoal_nome ?? "";
          const first = nome.trim().split(/\s+/)[0] || null;
          const avatar = data.img_usuario ?? null;
          setProfile(first, avatar);
        } else {
          clearProfile();
        }
      })
      .catch(() => clearProfile());
  }, [isLoggedIn, setProfile, clearProfile]);
}
